import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\GetImportTaskErrorsController::__invoke
* @see app/Http/Controllers/Import/GetImportTaskErrorsController.php
* @route '/api/import/{import}/task/{importTask}/errors'
*/
const GetImportTaskErrorsController = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetImportTaskErrorsController.url(args, options),
    method: 'get',
})

GetImportTaskErrorsController.definition = {
    methods: ["get","head"],
    url: '/api/import/{import}/task/{importTask}/errors',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Import\GetImportTaskErrorsController::__invoke
* @see app/Http/Controllers/Import/GetImportTaskErrorsController.php
* @route '/api/import/{import}/task/{importTask}/errors'
*/
GetImportTaskErrorsController.url = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            import: args[0],
            importTask: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: args.import,
        importTask: typeof args.importTask === 'object'
        ? args.importTask.id
        : args.importTask,
    }

    return GetImportTaskErrorsController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace('{importTask}', parsedArgs.importTask.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\GetImportTaskErrorsController::__invoke
* @see app/Http/Controllers/Import/GetImportTaskErrorsController.php
* @route '/api/import/{import}/task/{importTask}/errors'
*/
GetImportTaskErrorsController.get = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetImportTaskErrorsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Import\GetImportTaskErrorsController::__invoke
* @see app/Http/Controllers/Import/GetImportTaskErrorsController.php
* @route '/api/import/{import}/task/{importTask}/errors'
*/
GetImportTaskErrorsController.head = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetImportTaskErrorsController.url(args, options),
    method: 'head',
})

export default GetImportTaskErrorsController